import React from 'react';
import Transition from 'react-transition-group/Transition';
import classnames from 'classnames/bind';

import Notification from '../Notification';
import Icon from 'foundations/Icons/Icon';

import styles from './StandardNotification.css';

class StandardNotification extends Notification {
  static defaultProps = {
    role: 'alert',
    transitionDuration: 300
  }

  render () {
    const { additionalMessage, children, title, withIcon, timeout, transitionDuration, role } = this.props;
    const cx = classnames.bind(styles);
    const notificationClasses = cx('notification', { withIcon: withIcon });

    return (
      <Transition timeout={transitionDuration} in={this.state.active} appear unmountOnExit>
        {(status) => (
          <div
            className={classnames(notificationClasses, styles[status])}
            onMouseEnter={timeout && this.stopTimer}
            onMouseLeave={timeout && this.startTimer}
            role={role}
            style={{
              transitionDuration: `${transitionDuration}ms`
            }}
          >
            {withIcon &&
              <div className={styles.iconWrapper}>
                <Icon icon={withIcon.name} type={withIcon.type} />
              </div>}
            <div className={styles.notificationInnerBlock}>
              <a className={styles.closeButton} onClick={this.handleCloseButton} aria-label="close">
                <Icon icon={'close'} type={'15'} />
              </a>
              <p className={classnames('p', 'large', styles.informativeTitle)}>
                {title}
              </p>
              <p className={classnames('p', 'small', styles.message)}>
                {children}
              </p>
              {
                additionalMessage &&
                  <p className={classnames('p', 'small', styles.additionalMsg)}>
                    {additionalMessage}
                  </p>
              }
            </div>
          </div>
        )}
      </Transition>
    );
  }
}

export default StandardNotification;



// WEBPACK FOOTER //
// ./src/uis/components/Notification/StandardNotification/StandardNotification.js